import React from 'react'

const OutStock = () => {
  return (
    <div className="outstock">Out of Stock</div>
  )
}

export default OutStock